import React from 'react'
import axios from 'axios'
import { List, Box, Typography, Input, Select, MenuItem, Button, Divider, Menu, FormControl, FormGroup, Checkbox, Radio, FormControlLabel, RadioGroup, 
TableContainer, Table, TableRow, TableHead, TableBody, Paper, Pagination } from '@mui/material'
import { TextField, EditButton } from 'react-admin'
import globalStyles from '../../utils/globalStyles'
import SearchIcon from '@mui/icons-material/Search';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import SettingsIcon from '@mui/icons-material/Settings';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import CommonDataGrid from '../common/DataGrid';
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell'
import EditIcon from '@mui/icons-material/Edit';
import { useParams, useNavigate } from 'react-router-dom'
import legolasApi from '../../api/legolas'
import ChannelDropDown from '../common/ChannelDropDown'

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#2b3f7a',
    color: theme.palette.common.white,
    padding: globalStyles.common.infoTablesPadding,
    borderRight: '2px solid #fff',
    whiteSpace: 'nowrap',
    borderRadius: '0px !important'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: globalStyles.common.infoTablesPadding,
    borderRadius: '0px !important'
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

function CreditMemoList(props) {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [columnsOpen, setColumnsOpen]= React.useState(false)
  const [anchorCol, setAnchorCol] = React.useState(null)
  const [selectedHeaders, setSelectedHeaders] = React.useState([
   
    { id: 'increment_id', label: 'Credit Memo' }, { id: 'createdAt', label: 'Created'}, { id: 'orderId', label: 'Order #'}, { id: 'orderDate', label: 'Order Date'},
    { id: 'billingAddress', label: 'Bill-to Name'},  { id: 'grand_total', label: 'Refunded' }, { id: 'channelName', label: 'Channel'}
    
  ])
  const [currentPage, setCurrentPage] = React.useState(1)
  const [totalCount, setTotalCount] = React.useState(0)
  const [listData, setListData] = React.useState([])
  const [searchString, setSearchstring] = React.useState('')
  const navigate = useNavigate()
  const [channelData, setChannelData] = React.useState([]);
  const [channelFilterArray, setChannelFilterArray] = React.useState([]);
  const localStorageUser = localStorage.getItem('user');
  const user = JSON.parse(localStorageUser);
  const userChannels = Array.isArray(user?.channel) ? user.channel.map(String) : [];
  const allTableHeaders = [
   
    { id: 'increment_id', label: 'Credit Memo' }, { id: 'createdAt', label: 'Created'}, { id: 'orderId', label: 'Order #'}, { id: 'orderDate', label: 'Order Date'},
    { id: 'billingAddress', label: 'Bill-to Name'}, { id: 'grand_total', label: 'Refunded' }, { id: 'channelName', label: 'Channel'}
 
  ]

  const open = Boolean(anchorEl)
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleColumnClick = (e) =>  {
    setColumnsOpen(true)
    setAnchorCol(e.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null);
  };

  function findChecked(headerId, headerArr) {
    let checked = false
    for (let i = 0; i< headerArr.length; i++) {
      const checkElem = headerArr[i]
      if (checkElem['id'] == headerId) {
        checked = true
        break
      }
    }
    return checked
  }

  function selectHeader(headerId, headerLabel) {
    const headerObj = { "id": headerId, "label": headerLabel}
    const currentSelected = selectedHeaders
    currentSelected.push(headerObj)
    setColumnsOpen(false)
    setSelectedHeaders(currentSelected)
  }

  function resetTableHeaders() {
    setSelectedHeaders([
 
      { id: 'increment_id', label: 'Credit Memo' }, { id: 'createdAt', label: 'Created'}, { id: 'orderId', label: 'Order #'}, { id: 'orderDate', label: 'Order Date'},
      { id: 'billingAddress', label: 'Bill-to Name'},  { id: 'grand_total', label: 'Refunded' },{ id: 'channelName', label: 'Channel'}
 
    ])

    setColumnsOpen(false)
  }
  const buildCredittMemoPayload = (page = 1, searchStr = '', channelOverride = null) => {
  const offset = (page - 1) * 50;

  let channelPayload = channelOverride !== null
    ? channelOverride
    : (channelFilterArray?.length > 0 ? channelFilterArray : userChannels);

  const payload = {
    offset,
    limit: 50,
  };

  if (searchStr?.trim()) {
    payload.orderId = searchStr.trim();
  }

  if (channelPayload?.length > 0) {
    payload.channel = channelPayload;
  }

  return payload;
};
  const getChannel=()=>{
    axios.get(`${legolasApi.url}/admin/channel/list`)
    .then((res) => {
      console.log('order res: ', res.data.data);
      //setChannelData(res.data.data);
       const allChannels = res.data.data;
        const filteredChannels = allChannels.filter(ch => userChannels.includes(ch._id));
        setChannelData(filteredChannels);
    })
    .catch((error) => console.log('Error in getting orders: ', error));
  }
  React.useEffect(() => {
    getChannel();
   // const fetchAll = {}
      const fetchAll = buildCredittMemoPayload();
     axios.post(`${legolasApi.url}/admin/creditMemos`, fetchAll).then((data) => {
      console.log('Res: ', data)
      if (data.data.success) {
        setListData(data.data.data.data)
        setTotalCount(data.data.data.count)
      }
    })
   
  }, [])

  const formatDateAndTime = (inpDate) => {
    let retDate = ''
    const month = inpDate.toLocaleDateString('default', { month: 'short' })
    const date = inpDate.getDate()
    const year = inpDate.getFullYear()
    const formattedTime = inpDate.getHours() + ':' + inpDate.getMinutes() + ':' + inpDate.getSeconds()
    return retDate + month + '  ' + date + ',  ' +  year + '  ' + formattedTime
  }

  const handleEditClick = (orderId, order) => {
    const link =  `/creditMemo/${orderId}`
    navigate(link, { state: { data: order }})
  }

  const handleSearch = () => {
   // const searchQuery = { "orderId" : searchString }
      const payload = buildCredittMemoPayload(1);

    axios.post(`${legolasApi.url}/admin/creditMemos`, payload).then((res) => {
      // console.log('admin/creditMemos res: ', res)
      const data = res.data.data.data, count = res.data.data.count
      setListData(data)
      setTotalCount(count)
    }).catch((error) => console.log('Error in getting creditmemos: ', error))
  }

  const handleFilters = (field, value) => {
    console.log("channelFilterArray value",value)
    let newChannelFilterArray = channelFilterArray;;
     if (field === 'channel') {
      if (value === null) {
        newChannelFilterArray = null ;
    } else {
        newChannelFilterArray = value;
    }
    setChannelFilterArray(newChannelFilterArray);
    }

    console.log("channelFilterArray",channelFilterArray);
    const filterQuery = {
      //channel: newChannelFilterArray  
      channel: newChannelFilterArray.length ? newChannelFilterArray : userChannels

    };
    
    const payload = buildCredittMemoPayload(1, searchString, newChannelFilterArray);

    axios.post(`${legolasApi.url}/admin/creditMemos`, payload).then((res) => {
       
         const data = res.data.data.data, count = res.data.data.count
        setListData(data)
        setTotalCount(count);
      })
      .catch((error) => console.log('Error in credit memos: ', error))
  }

  const handlePagination = (event, value) => {
    console.log('Pagination value: ', value)
    const paginationPayload = {
      //"channel":  channelFilterArray == null||channelFilterArray.length === 0 ? null : channelFilterArray
      channel: channelFilterArray?.length ? channelFilterArray : userChannels,

    }
    axios.post(`${legolasApi.url}/admin/creditMemos?offset=${value-1}`,paginationPayload).then((res) => {
      console.log('nani res.data', res.data.data.data)
      const data = res.data.data.data, count = res.data.data.count
      setCurrentPage(value)
      setListData(data)
      setTotalCount(count)
    })
  }

  return (
    <React.Fragment>
      <List actions={null}>
        <Box sx={globalStyles.headerWrapperBox}>
          <Box sx={{ width: '50%', display: 'flex', margin: '20px 30px' }}>
            <Typography variant='h4'>Credit Memos</Typography>
            <Typography variant='subtitle1' sx={globalStyles.headerCountSubtitle}>
              {totalCount} record(s) found
            </Typography>
          </Box>
        </Box>
        <Box sx={globalStyles.headerWrapperBox}>
          <Box sx={{ 
              width: '100%', 
              display: 'flex', 
              margin: '0px 30px',
              '& .MuiInput-input': {
                width: '300px !important',
                padding: '5px 10px !important'
              },
              '& .MuiSvgIcon-root': {
                paddingRight: '10px'
              } 
            }}>
             <Input
                type='search' 
                sx={{ border: '1px solid #2b3f7a', borderRadius: '20px',height:'40px', marginTop:'20px',marginRight:'5%'  }} 
                endAdornment={<SearchIcon sx={{ cursor: 'pointer' }} onClick={() => handleSearch()}/>} 
                placeholder='Seach by Order ID'
                onChange={(e) => setSearchstring(e.target.value)}
              />
              { userChannels.length > 1 && ( <ChannelDropDown channelData={channelData} handleChannelFilter={handleFilters} /> )}
              {/* <Select
                labelId="demo-select-small"
                id="demo-select-small"
                style={{ backgroundColor: 'transparent', backgroundRepeat: 'repeat', color: globalStyles.colors.black, width: 'auto', minWidth: '200px', borderRadius: '20px', border: '1px solid #2b3f7a', marginLeft: '20px' }}
                label={'Action'}
                sx={{
                  '& .MuiSelect-select': {
                    margin: '0px 15px !important',
                    padding: '0px !important'
                  },
                  '& .MuiSelect-icon': {
                    position: 'relative',
                    right: 'unset !important',
                    top: 'unset !important'
                  }
                }}
                defaultValue=''
              >
                <MenuItem value={'delete'}>PDF Credit Memos</MenuItem>
              </Select> */}
              {/* <Box sx={{ 
                width: '43vw', 
                justifyContent: 'end', 
                textAlign: 'end',
                '& .MuiButton-sizeSmall': {
                  lineHeight: '30px !important' 
                },
                '& .MuiDivider-root': {
                  borderRightWidth: 'thin !important',
                  borderColor: '#2b3f7a'
                }
                }}>
                  <Button sx={globalStyles.listSubheaderIcons}>
                    <FilterAltIcon/> Filters <Divider orientation="vertical" flexItem sx={{ padding: '0px 10px' }}/>
                  </Button>
                  <Button sx={globalStyles.listSubheaderIcons} onClick={handleColumnClick}>
                    <SettingsIcon/> Columns <ArrowDropDownIcon sx={{ '& .MuiSvgIcon-root': { paddingRight: '0px !important' }}}/> <Divider orientation="vertical" flexItem sx={{ '& .MuiDivider-root': { borderRightWidth: 'normal' }}}/>
                  </Button>
                  <Menu
                    id="basic-menu"
                    anchorEl={anchorCol}
                    open={columnsOpen}
                    onClose={() => setColumnsOpen(false)}
                    MenuListProps={{
                      'aria-labelledby': 'basic-button',
                    }}
                  >
                    <FormControl>
                      <Box sx={{ margin: '10px 20px' }}>
                        <Typography>
                          {selectedHeaders.length} out of {allTableHeaders.length} visible
                        </Typography>
                      </Box>
                      <Box sx={{ width:'100%', borderTop: '1px solid #2b3f7a', borderBottom: '1px solid #2b3f7a', margin: '10px 20px', width: '92.5%' }}>
                      <FormGroup sx={{ display: 'grid', width: '100%', gridTemplateColumns: 'auto auto auto' }}>
                        {allTableHeaders.map((header) => {
                          if (header.id == 'id') {
                            return (
                              <FormControlLabel control={<Radio/>} label={header.label}/>
                            )
                          }else {
                            return (
                              <FormControlLabel control={
                              <Checkbox 
                                checked={findChecked(header.id, selectedHeaders)}/>} 
                                label={header.label}
                                onChange={(e) => selectHeader(header.id, header.label)}
                              />
                            )
                          }
                        })}
                    </FormGroup>
                    </Box>
                    <Box sx={{ display: 'flex', margin: '10px 20px', justifyContent: 'space-between !important', 
                      '& .MuiButton-root': {
                        textTransform: 'capitalize',
                        color: globalStyles.colors.backgroundPrimary
                      }}}
                    >
                      <Button onClick={() => resetTableHeaders()}>Reset</Button>
                      <Button onClick={() => setColumnsOpen(false)}>Cancel</Button>
                    </Box>
                  </FormControl>
                </Menu>
                <Button sx={globalStyles.listSubheaderIcons} onClick={handleClick}>
                  <FileUploadIcon/> Export <ArrowDropDownIcon sx={{ '& .MuiSvgIcon-root': { paddingRight: '0px !important' }}}/>
                </Button>
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  MenuListProps={{
                    'aria-labelledby': 'basic-button',
                  }}
                >
                  <FormControl>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      defaultValue="female"
                      name="radio-buttons-group"
                    >
                      <FormControlLabel value="csv" control={<Radio size='small'/>} label="CSV" />
                      <FormControlLabel value="excel" control={<Radio size='small'/>} label="Excel XML" />
                    </RadioGroup>
                    <Box>
                      <Button onClick={() => setAnchorEl(null)}>Cancel</Button>
                      <Button>Export</Button>
                    </Box>
                  </FormControl>
                </Menu>
              </Box> */}
            </Box>
        </Box>
        <Box>
          <TableContainer component={Paper} sx={{ margin: '20px 30px', width: '94%' }}>
          <Table aria-label="simple table">
              <TableHead sx={{ 
                backgroundColor: globalStyles.colors.backgroundPrimary, 
                height: '40px !important',
                borderRadius: '0 !important',
                '& .MuiTableCell-root': {
                  color: '#fff !important',
                  padding: '10px !important',
                  borderRight: '2px solid #fff !important',
                  borderRadius: '0 !important'
                }
              }}>
                {selectedHeaders.map((header) => [
                  <StyledTableCell align='center'>{header.label}</StyledTableCell>
                ])}
                <StyledTableCell align='center'>Action</StyledTableCell>
              </TableHead>
              <TableBody>
                {listData.map((order) => {
                      return (
                        <StyledTableRow id={order.id}>
                          {selectedHeaders.map((header) => {
                            if (header.id === 'createdAt') {
                              return (
                                <StyledTableCell align='center'>{formatDateAndTime(new Date(order[header.id]))}</StyledTableCell>
                              )
                            } else if (header.id == 'items') {
                              return (
                                <StyledTableCell align='center'>{order[header.id].length}</StyledTableCell>
                              )
                            }else if(header.id == 'billingAddress'){
                              const firstname = order?.billingAddress?.customer_firstname 
                              const lastname = order?.billingAddress?.customer_lastname
                              let fullName = ''
                              if (typeof firstname == 'string'){
                                fullName = fullName + firstname
                              }
                              if (typeof lastname == 'string'){
                                fullName = fullName + lastname
                              }
                              const formattedName = fullName.match(/.{1,30}/g) || [];
                              return(
                                <StyledTableCell align='center'>
                                  {/* {fullName} */}
                                  {formattedName.map((line, index) => (
                                <div key={index}>{line}</div>
                              ))}
                                </StyledTableCell>
                              )
                               } else if (header.id === 'grand_total') {
                                return (
                                  <StyledTableCell align="center" key={header.id}>
                                    {parseFloat(order[header.id]).toFixed(2)}
                                  </StyledTableCell>
                                )
                              } else {
                              return (
                                <StyledTableCell align='center'>
                                  {order[header.id]}
                                </StyledTableCell>
                              )
                            }
                          })}
                          <StyledTableCell align='center'>
                            <EditIcon sx={{ cursor: 'pointer', color: '#2b3f7a'}} onClick={() => handleEditClick(order.orderId, order)}/>
                          </StyledTableCell>
                        </StyledTableRow>
                      )
                    })}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        <Pagination count={Math.ceil(totalCount/50)} page={currentPage} onChange={handlePagination}/>
      </List>
    </React.Fragment>
  )
}

export default CreditMemoList;